import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn,
} from "@angular/common/http";
import { throwError, from, switchMap, Observable } from "rxjs";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AlertService } from "../services/alert.service";
import { AuthService } from "../services/auth.service";

export const HttpConfigInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const alertService = inject(AlertService);
  const router = inject(Router);
  const url = request.url;
  const currentRoute = router.url;

  // Detect if the request is FormData
  const isFormData = request.body instanceof FormData;

  const csvEndpoints = ["/wsDescargarListadoClientes", "/wsDescargarListadoComprobantes"];
 
  if (csvEndpoints.some((endpoint) => url.includes(endpoint))) {
  request = request.clone({
    headers: request.headers
      .delete("Content-Type")
      .set("Accept", "text/csv; charset=utf-8;"),
      responseType: 'blob' as 'json',
  });
 } else if (!isFormData) {
    request = request.clone({
      headers: request.headers
        .set("Content-Type", "application/json")
        .set("Accept", "application/json"),
    });
  }else {
    request = request.clone({
      headers: request.headers
        .delete("Content-Type")
        .set("Accept", "application/json, text/plain, */*"),
    });
  }

  // Si la ruta es "/dashboard", verificar autenticación antes de proceder
  if (currentRoute.includes("/dashboard") && !url.includes("/rest/refresh-token")) {
    return from(authService.isAuthenticated()).pipe(
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) {
          authService.logout();
          alertService.showStructuredError({
            title: 'Sesión expirada',
            cause: 'Tu sesión expiró por seguridad.',
            solution: 'Volvé a iniciar sesión para continuar.',
            confirmButtonText: 'ENTENDIDO'
          });
          return throwError(() => new Error("SESSION_EXPIRED"));
        }

        // Usuario autenticado, obtenemos el token actualizado antes de hacer la request
        const accessToken = localStorage.getItem("jwtToken");
        const tokenType = localStorage.getItem("tokenType");

        if (accessToken && tokenType) {
          request = request.clone({
            headers: request.headers.set(
              "Authorization",
              `${tokenType} ${accessToken}`
            ),
          });
        }

        return next(request);
      })
    );
  }

  // Si la ruta NO es "/dashboard", aplicar token sin verificación previa
  const accessToken = localStorage.getItem("jwtToken");
  const tokenType = localStorage.getItem("tokenType");

  if (accessToken && tokenType && !url.includes("/rest/refresh-token")) {
    request = request.clone({
      headers: request.headers.set(
        "Authorization",
        `${tokenType} ${accessToken}`,
      ),
    });
  }

  return next(request);
};
